"use client";

import * as React from "react";

interface BridgeMarkProps {
  className?: string;
}

export function BridgeMark({ className = "" }: BridgeMarkProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 18C6.2 14.8 8.9 13.2 12 13.2C15.1 13.2 17.8 14.8 20 18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path d="M7.5 18V8.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M16.5 18V8.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M5.5 8.5H18.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M3.5 18H8.5M15.5 18H20.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default BridgeMark;
